// Module
var code = " <div class=\"dv-accordion-tab-title\" ng-click=\"vm.vm.toggleTab(vm.tabid)\" ng-class=\"{'tab-open': vm.vm.isTagOpen(vm.tabid)}\" ng-transclude=\"title\"> {{ vm.title }} </div> <div class=\"dv-accordion-tab-content\" ng-show=\"vm.vm.isTagOpen(vm.tabid)\" ng-transclude=\"body\"></div> ";
// Exports
module.exports = code;